import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'

import RelatorioADView from './RelatorioADView'

export function RelatorioADRootView() {
  const match = useRouteMatch()

  return (
    <PecSwitch>
      <PrivateRoute
        exact
        path={`${match.url}`}
        component={RelatorioADView}
        permission={Permissions.atencaoDomiciliar}
      />
    </PecSwitch>
  )
}
